/*
 * Selector de Región / Comuna de despacho — siemprecompra.cl
 * - Se inserta en el carrito lateral (drawer) y en la página /cart, antes del botón "Finalizar compra".
 * - Obligatorio: sin región y comuna no deja ir al checkout.
 * - Pasa la comuna y región al checkout por URL (checkout[shipping_address][city] / [province]).
 * - Sin servidores externos, sin apps. Lista de comunas incluida.
 */
(function () {
  'use strict';
  if (window.__comunaDespachoLoaded) return;
  window.__comunaDespachoLoaded = true;

  var REGIONES = [
    { code: 'RM', name: 'Región Metropolitana', comunas: ['Alhué', 'Buin', 'Calera de Tango', 'Cerrillos', 'Cerro Navia', 'Colina', 'Conchalí', 'Curacaví', 'El Bosque', 'El Monte', 'Estación Central', 'Huechuraba', 'Independencia', 'Isla de Maipo', 'La Cisterna', 'La Florida', 'La Granja', 'La Pintana', 'La Reina', 'Lampa', 'Las Condes', 'Lo Barnechea', 'Lo Espejo', 'Lo Prado', 'Macul', 'Maipú', 'María Pinto', 'Melipilla', 'Ñuñoa', 'Padre Hurtado', 'Paine', 'Pedro Aguirre Cerda', 'Peñaflor', 'Peñalolén', 'Pirque', 'Providencia', 'Pudahuel', 'Puente Alto', 'Quilicura', 'Quinta Normal', 'Recoleta', 'Renca', 'San Bernardo', 'San Joaquín', 'San José de Maipo', 'San Miguel', 'San Pedro', 'San Ramón', 'Santiago', 'Talagante', 'Tiltil', 'Vitacura'] },
    { code: 'AP', name: 'Arica y Parinacota', comunas: ['Arica', 'Camarones', 'General Lagos', 'Putre'] },
    { code: 'TA', name: 'Tarapacá', comunas: ['Alto Hospicio', 'Camiña', 'Colchane', 'Huara', 'Iquique', 'Pica', 'Pozo Almonte'] },
    { code: 'AN', name: 'Antofagasta', comunas: ['Antofagasta', 'Calama', 'María Elena', 'Mejillones', 'Ollagüe', 'San Pedro de Atacama', 'Sierra Gorda', 'Taltal', 'Tocopilla'] },
    { code: 'AT', name: 'Atacama', comunas: ['Alto del Carmen', 'Caldera', 'Chañaral', 'Copiapó', 'Diego de Almagro', 'Freirina', 'Huasco', 'Tierra Amarilla', 'Vallenar'] },
    { code: 'CO', name: 'Coquimbo', comunas: ['Andacollo', 'Canela', 'Combarbalá', 'Coquimbo', 'Illapel', 'La Higuera', 'La Serena', 'Los Vilos', 'Monte Patria', 'Ovalle', 'Paihuano', 'Punitaqui', 'Río Hurtado', 'Salamanca', 'Vicuña'] },
    { code: 'VS', name: 'Valparaíso', comunas: ['Algarrobo', 'Cabildo', 'Calera', 'Calle Larga', 'Cartagena', 'Casablanca', 'Catemu', 'Concón', 'El Quisco', 'El Tabo', 'Hijuelas', 'Isla de Pascua', 'Juan Fernández', 'La Cruz', 'La Ligua', 'Limache', 'Llaillay', 'Los Andes', 'Nogales', 'Olmué', 'Panquehue', 'Papudo', 'Petorca', 'Puchuncaví', 'Putaendo', 'Quillota', 'Quilpué', 'Quintero', 'Rinconada', 'San Antonio', 'San Esteban', 'San Felipe', 'Santa María', 'Santo Domingo', 'Valparaíso', 'Villa Alemana', 'Viña del Mar', 'Zapallar'] },
    { code: 'LI', name: "O'Higgins", comunas: ['Chimbarongo', 'Chépica', 'Codegua', 'Coinco', 'Coltauco', 'Doñihue', 'Graneros', 'La Estrella', 'Las Cabras', 'Litueche', 'Lolol', 'Machalí', 'Malloa', 'Marchihue', 'Mostazal', 'Nancagua', 'Navidad', 'Olivar', 'Palmilla', 'Paredones', 'Peralillo', 'Peumo', 'Pichidegua', 'Pichilemu', 'Placilla', 'Pumanque', 'Quinta de Tilcoco', 'Rancagua', 'Rengo', 'Requínoa', 'San Fernando', 'San Vicente', 'Santa Cruz'] },
    { code: 'ML', name: 'Maule', comunas: ['Cauquenes', 'Chanco', 'Colbún', 'Constitución', 'Curepto', 'Curicó', 'Empedrado', 'Hualañé', 'Licantén', 'Linares', 'Longaví', 'Maule', 'Molina', 'Parral', 'Pelarco', 'Pelluhue', 'Pencahue', 'Rauco', 'Retiro', 'Río Claro', 'Romeral', 'Sagrada Familia', 'San Clemente', 'San Javier', 'San Rafael', 'Talca', 'Teno', 'Vichuquén', 'Villa Alegre', 'Yerbas Buenas'] },
    { code: 'NB', name: 'Ñuble', comunas: ['Bulnes', 'Chillán', 'Chillán Viejo', 'Cobquecura', 'Coelemu', 'Coihueco', 'El Carmen', 'Ninhue', 'Ñiquén', 'Pemuco', 'Pinto', 'Portezuelo', 'Quillón', 'Quirihue', 'Ránquil', 'San Carlos', 'San Fabián', 'San Ignacio', 'San Nicolás', 'Treguaco', 'Yungay'] },
    { code: 'BI', name: 'Biobío', comunas: ['Alto Biobío', 'Antuco', 'Arauco', 'Cabrero', 'Cañete', 'Chiguayante', 'Concepción', 'Contulmo', 'Coronel', 'Curanilahue', 'Florida', 'Hualpén', 'Hualqui', 'Laja', 'Lebu', 'Los Álamos', 'Los Ángeles', 'Lota', 'Mulchén', 'Nacimiento', 'Negrete', 'Penco', 'Quilaco', 'Quilleco', 'San Pedro de la Paz', 'San Rosendo', 'Santa Bárbara', 'Santa Juana', 'Talcahuano', 'Tirúa', 'Tomé', 'Tucapel', 'Yumbel'] },
    { code: 'AR', name: 'Araucanía', comunas: ['Angol', 'Carahue', 'Cholchol', 'Collipulli', 'Cunco', 'Curacautín', 'Curarrehue', 'Ercilla', 'Freire', 'Galvarino', 'Gorbea', 'Lautaro', 'Loncoche', 'Lonquimay', 'Los Sauces', 'Lumaco', 'Melipeuco', 'Nueva Imperial', 'Padre Las Casas', 'Perquenco', 'Pitrufquén', 'Pucón', 'Purén', 'Renaico', 'Saavedra', 'Temuco', 'Teodoro Schmidt', 'Toltén', 'Traiguén', 'Victoria', 'Vilcún', 'Villarrica'] },
    { code: 'LR', name: 'Los Ríos', comunas: ['Corral', 'Futrono', 'La Unión', 'Lago Ranco', 'Lanco', 'Los Lagos', 'Máfil', 'Mariquina', 'Paillaco', 'Panguipulli', 'Río Bueno', 'Valdivia'] },
    { code: 'LL', name: 'Los Lagos', comunas: ['Ancud', 'Calbuco', 'Castro', 'Chaitén', 'Chonchi', 'Cochamó', 'Curaco de Vélez', 'Dalcahue', 'Fresia', 'Frutillar', 'Futaleufú', 'Hualaihué', 'Llanquihue', 'Los Muermos', 'Maullín', 'Osorno', 'Palena', 'Puerto Montt', 'Puerto Octay', 'Puerto Varas', 'Puqueldón', 'Purranque', 'Puyehue', 'Queilén', 'Quellón', 'Quemchi', 'Quinchao', 'Río Negro', 'San Juan de la Costa', 'San Pablo'] },
    { code: 'AI', name: 'Aysén', comunas: ['Aysén', 'Chile Chico', 'Cisnes', 'Cochrane', 'Coyhaique', 'Guaitecas', 'Lago Verde', "O'Higgins", 'Río Ibáñez', 'Tortel'] },
    { code: 'MA', name: 'Magallanes', comunas: ['Antártica', 'Cabo de Hornos', 'Laguna Blanca', 'Natales', 'Porvenir', 'Primavera', 'Punta Arenas', 'Río Verde', 'San Gregorio', 'Timaukel', 'Torres del Paine'] }
  ];

  var LS_KEY = 'sc_comuna_despacho_v1';
  var CSS =
    '.comuna-despacho{margin:0 0 12px;padding:14px 0 12px;border-top:1px solid #e1e3e4;border-bottom:1px solid #e1e3e4;text-align:left}' +
    '.comuna-despacho .cd-title{font-size:15px;font-weight:700;margin:0 0 4px;line-height:1.3}' +
    '.comuna-despacho .cd-help{font-size:12px;color:#666;margin:0 0 10px;line-height:1.35}' +
    '.comuna-despacho .cd-row{display:grid;grid-template-columns:1fr 1fr;gap:8px}' +
    'cart-drawer .comuna-despacho .cd-row{grid-template-columns:1fr}' +
    '@media (max-width:749px){.comuna-despacho .cd-row{grid-template-columns:1fr}}' +
    '.comuna-despacho select{appearance:none;-webkit-appearance:none;width:100%;background-color:#f1f1f3;border:1px solid transparent;font-size:14px;line-height:1.2;padding:11px 34px 11px 12px;outline:none;cursor:pointer;color:#111;border-radius:4px;' +
    'background-image:url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'12\' height=\'12\' viewBox=\'0 0 12 12\'%3E%3Cpath fill=\'%23000\' d=\'M6 8L1 3h10z\'/%3E%3C/svg%3E");background-repeat:no-repeat;background-position:right 12px center}' +
    '.comuna-despacho select:disabled{opacity:.55;cursor:not-allowed}' +
    '.comuna-despacho select.cd-invalid{border-color:#e21c24}' +
    '.comuna-despacho select.cd-valid{border-color:#22aa73}' +
    '.comuna-despacho .cd-error{color:#e21c24;font-size:13px;font-weight:600;margin-top:8px}' +
    '.comuna-despacho .cd-error[hidden]{display:none}';

  function injectStyle() {
    if (document.getElementById('comuna-despacho-css')) return;
    var s = document.createElement('style');
    s.id = 'comuna-despacho-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function getState() {
    try { return JSON.parse(localStorage.getItem(LS_KEY) || '{}') || {}; } catch (e) { return {}; }
  }
  function setState(s) {
    try { localStorage.setItem(LS_KEY, JSON.stringify(s)); } catch (e) { /* noop */ }
  }
  function findRegion(code) {
    for (var i = 0; i < REGIONES.length; i++) if (REGIONES[i].code === code) return REGIONES[i];
    return null;
  }
  function escapeHtml(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function fillComunas(select, regionCode, selected) {
    var r = findRegion(regionCode);
    var html = '<option value="">Comuna</option>';
    if (r) {
      for (var i = 0; i < r.comunas.length; i++) {
        var c = r.comunas[i];
        html += '<option value="' + escapeHtml(c) + '"' + (c === selected ? ' selected' : '') + '>' + escapeHtml(c) + '</option>';
      }
    }
    select.innerHTML = html;
    select.disabled = !r;
  }

  function syncAll() {
    var s = getState();
    var all = document.querySelectorAll('.comuna-despacho');
    for (var i = 0; i < all.length; i++) {
      var ui = all[i];
      var rs = ui.querySelector('.cd-region');
      var cs = ui.querySelector('.cd-comuna');
      if (rs.value !== (s.region || '')) rs.value = s.region || '';
      fillComunas(cs, s.region || '', s.comuna || '');
      var ok = !!(s.region && s.comuna);
      rs.classList.toggle('cd-valid', !!s.region);
      cs.classList.toggle('cd-valid', ok);
      if (ok) {
        rs.classList.remove('cd-invalid');
        cs.classList.remove('cd-invalid');
        ui.querySelector('.cd-error').hidden = true;
      }
    }
  }

  function build() {
    var ui = document.createElement('div');
    ui.className = 'comuna-despacho';
    var opts = '<option value="">Región</option>';
    for (var i = 0; i < REGIONES.length; i++) {
      opts += '<option value="' + REGIONES[i].code + '">' + escapeHtml(REGIONES[i].name) + '</option>';
    }
    ui.innerHTML =
      '<div class="cd-title">Comuna de despacho</div>' +
      '<div class="cd-help">Elige tu región y comuna; se completan solas en el checkout para evitar errores en el envío.</div>' +
      '<div class="cd-row">' +
        '<select class="cd-region" aria-label="Región de despacho" required>' + opts + '</select>' +
        '<select class="cd-comuna" aria-label="Comuna de despacho" required disabled><option value="">Comuna</option></select>' +
      '</div>' +
      '<div class="cd-error" hidden>Selecciona tu región y comuna de despacho para continuar.</div>';

    var rs = ui.querySelector('.cd-region');
    var cs = ui.querySelector('.cd-comuna');

    rs.addEventListener('change', function () {
      var s = getState();
      s.region = rs.value;
      s.comuna = '';
      setState(s);
      syncAll();
    });
    cs.addEventListener('change', function () {
      var s = getState();
      s.region = rs.value;
      s.comuna = cs.value;
      setState(s);
      syncAll();
    });
    return ui;
  }

  function mount() {
    injectStyle();
    // Carrito lateral (drawer): antes del formulario con el botón Finalizar compra
    var drawerForms = document.querySelectorAll('cart-drawer form.drawer__footer-buttons');
    for (var i = 0; i < drawerForms.length; i++) {
      var f = drawerForms[i];
      if (!f.parentElement.querySelector('.comuna-despacho')) f.parentElement.insertBefore(build(), f);
    }
    // Página /cart: antes del botón Finalizar compra
    var cartBtns = document.querySelectorAll('.cart__footer--buttons button[name="checkout"]');
    for (var j = 0; j < cartBtns.length; j++) {
      var b = cartBtns[j];
      if (!b.parentElement.querySelector('.comuna-despacho')) b.parentElement.insertBefore(build(), b);
    }
    syncAll();
  }

  function showError(ui) {
    if (!ui) return;
    var rs = ui.querySelector('.cd-region');
    var cs = ui.querySelector('.cd-comuna');
    if (!rs.value) rs.classList.add('cd-invalid');
    if (!cs.value) cs.classList.add('cd-invalid');
    ui.querySelector('.cd-error').hidden = false;
    try { ui.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { /* noop */ }
    (rs.value ? cs : rs).focus();
  }

  function facturaIncompleta() {
    // Respeta la validación del formulario de factura de la página /cart
    var radio = document.getElementById('btn-factura');
    if (!radio || !radio.checked) return false;
    var ids = ['Razón social', 'Giro', 'Región', 'Comuna', 'Direccion'];
    for (var i = 0; i < ids.length; i++) {
      var el = document.getElementById(ids[i]);
      if (el && !String(el.value || '').trim()) return true;
    }
    return false;
  }

  function checkoutUrl(s) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var p = new URLSearchParams();
    p.set('checkout[shipping_address][country]', 'Chile');
    p.set('checkout[shipping_address][province]', s.region);
    p.set('checkout[shipping_address][city]', s.comuna);
    return root + 'checkout?' + p.toString();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('button[name="checkout"]') : null;
    if (!btn) return;
    var scope = btn.closest('cart-drawer') || btn.closest('.cart__footer') || document;
    var ui = scope.querySelector('.comuna-despacho') || document.querySelector('.comuna-despacho');
    if (!ui) return; // no hay selector en este contexto: comportamiento normal
    var s = getState();
    if (!s.region || !s.comuna || !findRegion(s.region)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showError(ui);
      return;
    }
    if (facturaIncompleta()) return; // deja que el formulario de factura muestre su error
    e.preventDefault();
    e.stopImmediatePropagation();
    btn.setAttribute('aria-busy', 'true');
    window.location.href = checkoutUrl(s);
  }, true);

  var timer = null;
  var mo = new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(mount, 60);
  });

  function start() {
    mount();
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();